import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import "../../../css/ISI.scss";

// const startScrollTo = (event) => {
//   const currentPath = window.location.pathname;
//   const href = event.target.getAttribute("href");
//   const hrefParts = href.split("#");
//   if (hrefParts[0] === currentPath) {
//     event.preventDefault();
//     const element = document.getElementById(hrefParts[1]);
//     scrollToElement(element);
//   }
// };

// const scrollToElement = (element) => {
//   setTimeout(() => {
//     element.scrollIntoView({
//       behavior: "smooth",
//       block: "start",
//     });
//   }, 1000);
// };

export default function ISIITP_inline() {
  return (
    <div className="isi-inline-wrapper isi-inline-itp" id="isi">
      <div className="isi-content">
        <div className="inline-isi-header">
          <Container>
            <p>Indication & Important Safety Information</p>
          </Container>
        </div>
        <Container>
          <p className="text-blue"><strong>What are DOPTELET (avatrombopag) and DOPTELET Sprinkle (avatrombopag)?</strong></p>
          <p className="mb-0">DOPTELET is a prescription medicine used to treat low blood platelet counts in:</p>
          <ul className="mb-2">
            <li>Adults with long-lasting (chronic) liver disease (CLD) who are scheduled to have a medical or dental procedure</li>
            <li>Adults with chronic immune thrombocytopenia (ITP) when other treatments have not worked well enough.</li>
            <li>Children 1 year and older with persistent or chronic ITP when other treatments have not worked well enough</li>
          </ul>
          <p className="mb-2">DOPTELET tablets and DOPTELET Sprinkle are different dosage forms of DOPTELET.</p>
          <p className="mb-2">DOPTELET and DOPTELET Sprinkle are not used to make platelet counts normal.</p>
          <p className="mb-2">It is not known if DOPTELET or DOPTELET Sprinkle are safe and effective in children younger than 1 year of age.</p>
          <p className="text-blue mb-1"><strong>IMPORTANT SAFETY INFORMATION</strong></p>
          <p className="mb-0"><strong>Before you take DOPTELET or DOPTELET Sprinkle,</strong> tell your doctor about all your medical conditions, including if you:</p>
          <ul className="mb-2">
            <li>Have ever had a blood clot</li>
            <li>Are pregnant or plan to become pregnant. DOPTELET or DOPTELET Sprinkle may harm your unborn baby. Tell your healthcare provider if you become pregnant or think you may be pregnant during treatment with DOPTELET or DOPTELET Sprinkle</li>
            <li>Are breastfeeding or plan to breastfeed. It is not known if DOPTELET or DOPTELET Sprinkle passes into your breast milk. Do not breastfeed during your treatment with DOPTELET and DOPTELET Sprinkle for at least 2 weeks after the last dose. Talk to your healthcare provider about the best way to feed your baby during this time</li>
          </ul>

          <p className="mb-2"><strong>Tell your healthcare provider about all of the medicines you take, including</strong> prescription and over-the-counter medicines, vitamins, and herbal supplements. DOPTELET or DOPTELET Sprinkle may affect the way other medicines work, and other medicines may affect the way DOPTELET or DOPTELET Sprinkle works.</p>
          <p className="text-blue"><strong>What are the side effects of DOPTELET or DOPTELET Sprinkle?</strong></p>
          <p className="mb-0">DOPTELET or DOPTELET Sprinkle may cause serious side effects including <strong>blood clots</strong>. People with CLD or persistent or chronic ITP and people with certain blood clotting conditions may have an increased risk of developing blood clots. Tell your healthcare provider right away if you get signs and symptoms of a blood clot, including: </p>
          <div className="d-md-flex">
            <ul className="mb-2 col-md-6">
              <li>Swelling, pain, or tenderness in your legs</li>
              <li>Shortness of breath</li>
              <li>Chest pain</li>
            </ul>
            <ul className="mb-3 col-md-6">
              <li>Fast heartbeat</li>
              <li>Stomach (abdominal) pain or tenderness</li>
            </ul>
          </div>
          <p className="mb-1"><strong>The most common side effects of DOPTELET in adults with CLD are</strong> fever, stomach (abdominal) pain, nausea, headache, tiredness, and swelling of hands and feet.</p>

          <p className="mb-1"><strong>The most common side effects of DOPTELET in adults with chronic ITP are</strong> headache, tiredness, bruising, nosebleed, upper respiratory infection, joint pain, bleeding gums, purple or red spots on your skin, and runny nose.</p>
          <p className="mb-1"><strong>The most common side effects of DOPTELET or DOPTELET Sprinkle in children with persistent or chronic ITP are</strong> viral infection, runny nose, cough, fever, and pain in the mouth or throat. </p>
          <p>These are not all of the possible side effects of DOPTELET or DOPTELET Sprinkle. Call your doctor for medical advice about side effects. You may report side effects to FDA at <a href="tel:1-800-332-1088" className="no-break"><strong>1-800-FDA-1088</strong></a>.</p>
          <p>
            Please see the DOPTELET and DOPTELET Sprinkle full{" "}
            <Link
              to={{
                pathname:
                  "/themes/pdf/prescribing-information.pdf",
              }}
              target="_blank"
            >
              Prescribing Information
            </Link>
            .
          </p>
        </Container>
      </div>
    </div>
  );
}
